/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_Manage_EmptyInputs */

const en_ui_trips_manage_empty = /** @type {(inputs: Ui_Trips_Manage_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a trip first`)
};

const de_ui_trips_manage_empty = /** @type {(inputs: Ui_Trips_Manage_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erst eine Tour erstellen`)
};

/**
* | output |
* | --- |
* | "Create a trip first" |
*
* @param {Ui_Trips_Manage_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_manage_empty = /** @type {((inputs?: Ui_Trips_Manage_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Manage_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_manage_empty(inputs)
	return de_ui_trips_manage_empty(inputs)
});